import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/report';
import { Tournament } from '../../../../../../models/tournament';
import { TournamentReportOptionsForm } from '../TournamentReportOptionsForm';
interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  tournament: Tournament;
}
export function TournamentStartListReportForm(props: Props) {
  return (
    <TournamentReportOptionsForm
      {...props}
      reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TOURNAMENT_START_LIST}
      description="View event start lists and the schools that entered students into each event."
      options={[
        {
          field: 'isShowBlank',
          label: 'Show empty entries',
          hint: 'Include schools or teams that have not added participants.',
          initialValue: true
        },
        {
          field: 'isHighlightNoAge',
          label: 'Highlight students without DOB',
          hint: 'Highlight students whose date of birth is missing.',
          initialValue: true
        },
        {
          field: 'isPrintScoreCards',
          label: 'Include score cards',
          hint: 'Generate separate printable score cards for each event.',
          initialValue: false
        }
      ]}
    />
  );
}
